module.exports = __webpack_public_path__ + "static/iPhone-Screen-f197579f27d9676d6742018689ae6f3d.png";